/**
 * created by lzy 2021-01-21
 * 送审支持指定审核人
 */

'use strict';

angular.module('flowWithVerifierModule', []).controller('flowWithVerifierCtrl', ['$scope', '$modalInstance', 'iwoNoticeService', 'options',
    function($scope, $modalInstance, iwoNoticeService, options) {
        initStatus();
        
        /**
         * [initStatus description] 初始化数据状态
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.data = {
                title: options.title || '送审',
                placeholder: options.placeholder || '请输入',
                canDesignatedAuditor: options.canDesignatedAuditor,
                content: options.content || '',
                selected: {}
            };
        }

        $scope.selected = function() {
            iwoNoticeService.userAndDeptTransfer('', '', $scope.data.selected.selectedArray || [], $scope.data.selected.selectedType || 0, [0, 1], '选择审核人').then(function(data) {
                $scope.data.selected = data;
                $scope.data.inputValue = data.selectedArray.map(function(item) {
                    return item.USERNAME || item.GNAME;
                }).join('、');
            });
        };

        $scope.confirm = function() {
            $modalInstance.close({
                opinion: $scope.data.content,
                selected: $scope.data.selected
            });
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }
]);
